import React, { cloneElement, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { loadAIDiagnosisQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import useAmplitude from "../../../../hooks/useAmplitude";
import { URL } from "../../../../constant";

const Closer = ( props ) => {

  const history = useHistory();
  const { setAmplitudeLog } = useAmplitude();

  const dispatch = useDispatch();
  const questionData = useSelector(state => state.amplitudeLogData.question_data);
  const loadAIDiagnosisQuestion = payload => { dispatch( loadAIDiagnosisQuestionAction( payload ) ) };

  const close = () => {

    loadAIDiagnosisQuestion( { progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.USER_CLOSE } );
    setAmplitudeLog({
      eventName: {
        name: '진단문항풀이 이탈',
        event: {
          "소주제이름": questionData.stepNm,
          "소주제코드": questionData.stgCd,
          "문항코드": questionData.qstCd,
          "커리큘럼그룹": questionData.thmaNm,
          "커리큘럼명": questionData.stepNm,
        }
      }
    });
    history.replace(`${URL.SELECT_LEARNING}`, null);
  };

  return cloneElement( props.children || <Fragment />, {
    onClose : close
  } );

};

export default Closer;
